import { Component, ViewEncapsulation, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ProjectGQL, SwitchAccountGQL } from "../../../../generated/graphql";
import { AuthService } from "../../../authentication/oidc/auth.service";
import { HeaderService } from "../../service/header.service";
import { UserService } from "../../service/user.service";
import { SnackBarService } from "../../service/snack.bar.service";
import { NavigationService } from "../../service/navigation.service";

@Component({
  selector: "switch-account-dialog",
  templateUrl: "switch-account-dialog.html",
  styles: [
    ".switch-project-dialog .ps > .ps__rail-x, .switch-project-dialog .ps > .ps__rail-y { opacity: 0.6; }",
  ],
  styleUrls: ['././switch-account-dialog.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SwitchAccountDialog implements OnInit, OnDestroy {
  public psConfig: PerfectScrollbarConfigInterface = {};

  accountList: any = [];

  value: String;
  projects: any;
  allowAddProject: Boolean;

  constructor(
    public dialogRef: MatDialogRef<SwitchAccountDialog>,
    userService: UserService,
    private authService: AuthService,
    private switchAccountGQL: SwitchAccountGQL,
    public headerService: HeaderService,
    private snackBarService: SnackBarService,
    private navigationService: NavigationService,
    private projectGQL: ProjectGQL,
  ) {
    this.accountList = userService.AccountList.filter(
      (x) => x.id != authService.userContext.accountId
    );
    this.getData();
  }

  getData() {
    this.projectGQL.fetch().subscribe(
      (result) => {
        this.projects = result.data.getAllProject;
        this.allowAddProject = result.data.allowAddProject
      },
      (err) => {
        this.snackBarService.show(err.graphQLErrors[0].message);
      }
    );
  }

  initSearch() {
    (<any>$(".search-account")).toggle(250);
    let elementShow = document.getElementById("input-search")
    elementShow.style.display = "block";

    let elementHide = document.getElementById("company-listing")
    elementHide.style.display = "none";

    let closeButton = document.getElementById("closeButton")
    closeButton.style.display = "block";
  }

  closeSearch() {
    this.value = "";
    this.navigationService.setState("");
    (<any>$(".search-account")).toggle(250);

    let elementHide = document.getElementById("input-search")
    elementHide.style.display = 'none';

    let elementShow = document.getElementById("company-listing")
    elementShow.style.display = 'block';
  }

  ngOnInit() {
    if (this.navigationService.getState()) {
      this.value = this.navigationService.getState()
      this.initSearch();
    }
  }

  ngOnDestroy(): void {
    this.navigationService.setState(this.value);
  }

  switchAccount(id: string) {
    this.switchAccountGQL
      .fetch({
        accountID: id,
      })
      .subscribe((result) => {
        let token = result.data.refreshToken;
        this.authService.setToken(token);

        if (
          this.headerService.header &&
          !this.headerService.header.disableProject
        )
          location.href = "/";
        else location.reload();
      });
  }
}
